const API_KEY = "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";

export default API_KEY;
